<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bVNxms/tc-custom/9781504010023.jpg?1693447294112" alt="This image is the cover for the book Stronger Than Magic"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stronger Than Magic
      </h1>
      <p class="bookDescription body article font2">
        <b>In this enchanting romance, a cursed beauty and a man with an endangered soul are transported through space and time to be reunited in Regency-era England for one last chance at redemption—could their love be stronger than the spell that binds them? </b><br/><br/> Born to a faerie father and a mortal mother, Lucan lacks one thing: a soul. To become complete, he must fall in love. When he does—with spoiled, willful Alys le Fayre—his life ends tragically. Too late, Alys realizes that Lucan was her soul mate. Now imprisoned in the faerie underworld as punishment for causing Lucan’s death, she is fated to spend the next millennia helping humans find happiness. But she’s never forgotten the love she lost.<br/>  <br/> Her chance for redemption comes in 1816, when she’s tasked with finding the perfect woman for Lucian Warre, the seventh Marquess of Thistlewood, who is Lucan reborn into his final life. The catch? She has only 130 days before tragedy once again befalls the half-mortal Lucian, who doesn’t believe in love and never intends to marry. But Alys has other plans . . .<br/>  <br/> Heather Cullman delivers a timeless romantic tale about two people whose love transcends time, fate, and intervention—both human and otherworldly.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Heather Cullman
      </h2>
      
      <p class="authorDescription body article">Heather Cullman has a degree in fashion and design and has always wanted to be a writer. She lives with her husband, a lawyer, in Long Beach, California. She is the author of eight historical romances.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3db5699c